import { render, staticRenderFns } from "./QueueView.vue?vue&type=template&id=645286b0"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645286b0')) {
      api.createRecord('645286b0', component.options)
    } else {
      api.reload('645286b0', component.options)
    }
    module.hot.accept("./QueueView.vue?vue&type=template&id=645286b0", function () {
      api.rerender('645286b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/QueueView.vue"
export default component.exports